import React from "react";
import SensorBase from "./SensorBase";
import { TSensorDataResponse } from "../../../services/sensorData.service";
import { TChartData } from "../types";
import { TInformationCard } from "../components/InformationCardRenderer";
import { t } from "../../../services/locale.service";

const FIELD = "rainFall";
const UNIT = "mm";

const RainFall: React.FC = () => {
  const customProcessFn = (graphData: TSensorDataResponse) => {
    if(!graphData?.sum) {
      graphData.sum = graphData?.sample.reduce((sum, curr) => sum + Number(curr.rainFall) ?? 0, 0);
    }

    return JSON.parse(JSON.stringify(graphData)) as TSensorDataResponse;
  };

  const generateInformationCard = (chartData: TChartData): Array<TInformationCard> => {
    const { sum } = chartData;
    return [{
      cardTitle: t("TotalRainFall"),
      value: sum ?? 0,
      information: "",
      unit: UNIT
    }];
  };

  return (
    <SensorBase field={FIELD} unit={UNIT} customProcessFn={customProcessFn} customInformationCards={generateInformationCard}></SensorBase>
  );
};

export default RainFall;

